/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetMaintenanceScheduleQueryResponse, GetMaintenanceSchedulePathParams, GetMaintenanceScheduleQueryParams, GetMaintenanceSchedule400, GetMaintenanceSchedule401, GetMaintenanceSchedule403, GetMaintenanceSchedule404, GetMaintenanceSchedule409, GetMaintenanceSchedule500 } from "../../types/equipmentController/GetMaintenanceSchedule.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetMaintenanceScheduleUrl(organizationId: GetMaintenanceSchedulePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/schedule` as const }
  return res
}

/**
 * @summary Get maintenance schedule
 * {@link /api/organizations/:organizationId/equipment/schedule}
 */
export async function getMaintenanceSchedule(organizationId: GetMaintenanceSchedulePathParams["organizationId"], params?: GetMaintenanceScheduleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetMaintenanceScheduleQueryResponse, ResponseErrorConfig<GetMaintenanceSchedule400 | GetMaintenanceSchedule401 | GetMaintenanceSchedule403 | GetMaintenanceSchedule404 | GetMaintenanceSchedule409 | GetMaintenanceSchedule500>, unknown>({ method : "GET", url : getGetMaintenanceScheduleUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}